Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconBulbData: "data:image/svg+xml,%3csvg width='14' height='20' xmlns='http://www.w3.org/2000/svg'%3e%3cg stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd'%3e%3cpath d='M4 15c0-2-.72-2.92-2-4.68M12 10.32C10.72 12.08 10 13 10 15M4 19h6' stroke-linecap='round' stroke-linejoin='round'/%3e%3cpath d='M2 10.36a6 6 0 1110 0'/%3e%3cpath d='M4 15h6M7 5a2 2 0 012 2' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/g%3e%3c/svg%3e",
  iconBulbWidth: 14,
  iconBulbHeight: 20
};